import { useNavigate, useLocation } from "react-router-dom";
import { Briefcase, User } from "lucide-react";
import { useViewContext } from "@/contexts/ViewContext";
import { useAccessResolver } from "@/hooks/useAccessResolver";
import { useTranslation } from "@/hooks/useTranslation";
import { isCleanerJobRunnerPath } from "@/lib/turnoverChrome";
import { cn } from "@/lib/utils";

export const CleanerBottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { viewContext } = useViewContext();
  const { data: access } = useAccessResolver();
  const { t } = useTranslation();

  if (viewContext !== "cleaner") return null;
  if (access?.type === "single_task") return null;
  if (isCleanerJobRunnerPath(location.pathname)) return null;

  const navItems = [
    { icon: Briefcase, label: t("jobs"), path: "/worker/schedule" },
    { icon: User, label: t("profile"), path: "/account" },
  ];

  const isActive = (path: string) => {
    if (path === "/worker/schedule") {
      return (
        location.pathname === path ||
        location.pathname.startsWith("/clean/") ||
        location.pathname.startsWith("/worker/")
      );
    }
    if (path === "/account") {
      return location.pathname === "/account" || location.pathname.startsWith("/account/");
    }
    return location.pathname === path || location.pathname.startsWith(path);
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 border-t-[1.5px] border-[#e6edf1] bg-white safe-area-bottom md:hidden">
      <div className="flex h-16 items-center justify-around">
        {navItems.map((item) => (
          <button
            key={item.path}
            type="button"
            onClick={() => navigate(item.path)}
            className={cn(
              "flex flex-1 flex-col items-center gap-[3px] text-[12px] font-bold transition-colors",
              isActive(item.path) ? "text-[#24a89a]" : "text-[#94a3b8]",
            )}
          >
            <item.icon className="h-6 w-6" strokeWidth={2.2} />
            <span>{item.label}</span>
          </button>
        ))}
      </div>
    </nav>
  );
};
